import React from 'react';
import TextboxField from '../../../components/Fields/TextboxField';
import { FieldProps } from '../../../components/Fields/Types';
import WorkflowTaskEditItemModel from '../../../models/WorkflowTaskEditItemModel';

interface IProps {
    formData: WorkflowTaskEditItemModel
    getFieldProps: (fieldName: string) => FieldProps
}

const TaskEditItemView: React.FC<IProps> = ({ formData, getFieldProps }) => {
    return (
        <>
            <TextboxField {...getFieldProps('workflowTaskEditItemModel.itemName')} />
            <TextboxField {...getFieldProps('workflowTaskEditItemModel.itemDescription')} />
        </>
    )
}
export default TaskEditItemView;
